
const digest = '26f4823603f89ada9db038d6b49d6de4589a81f0c9b61e93c195aae8c7b8ca02';
const classes = {"button":"_button_o0qnt_1","selected":"_selected_o0qnt_19"};
const css = `._button_o0qnt_1 {
  flex: 1;
  background-color: rgba(22, 101, 216, 0.1);
  color: #1665D8;
  font-weight: 700;
  padding: 5px 10px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  min-width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
._button_o0qnt_1:hover {
  cursor: pointer;
}
._button_o0qnt_1._selected_o0qnt_19 {
  background-color: #1665D8;
  color: white;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  